import { AroundCityTransport } from 'common/types';
import { Co2FootprintVO } from 'vo';

// TODO: think about move this logic to calculate-movement.ts

const AVERAGE_COVERED_DISTANCE_KM_PER_DAY = 5;

const getCo2ePerKmByTransport = (transport: AroundCityTransport) => {
  /**
   * Emission factors updated January 2026.
   * Source: UK DESNZ/DEFRA Greenhouse Gas Conversion Factors 2025
   * https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2025
   */
  const mapping = {
    [AroundCityTransport.WALK]: 0,
    [AroundCityTransport.CYCLE]: 0,
    [AroundCityTransport.TAXI]: 0.14549, // Regular taxi (DEFRA 2025)
    [AroundCityTransport.BUS]: 0.10385, // Average local bus (DEFRA 2025)
    [AroundCityTransport.PRIVATE_CAR]: 0.16272, // Petrol car average (DEFRA 2025)
    [AroundCityTransport.ELICTRIC_CAR_OR_TAXI]: 0.04047, // Battery EV (DEFRA 2025)
  };
  return mapping[transport];
};

type Params = {
  transport: AroundCityTransport;
  peopleCount: number;
  tripDaysCount: number;
};

export default (params: Params) => {
  const { transport, tripDaysCount, peopleCount } = params;

  const isZeroCo2FootprintTransport = [AroundCityTransport.WALK, AroundCityTransport.CYCLE].includes(transport);
  if (isZeroCo2FootprintTransport) {
    return Co2FootprintVO.create({ perPerson: 0, total: 0 });
  }

  const perKm = getCo2ePerKmByTransport(transport);
  const perPerson = perKm * AVERAGE_COVERED_DISTANCE_KM_PER_DAY * tripDaysCount;
  const total = perPerson * peopleCount;

  return Co2FootprintVO.create({ perPerson, total });
};
